import { colors, fonts } from '../theme';

const columns = [
  {
    title: 'Regulatory pressure',
    items: [
      <><b>EU Digital Product Passport</b> — mandatory machine-readable data for batteries from February 2027, with textiles, electronics, steel, and aluminium following through 2028–2030.</>,
      <><b>CBAM &amp; REACH</b> require traceable, auditable data on origin and composition — not just declarations.</>,
      <><b>ISO, IEC &amp; BIS SMART standards</b> are shifting from static PDFs to machine-executable requirement logic.</>,
    ],
  },
  {
    title: 'Buyer expectations',
    items: [
      'Automotive and aerospace buyers now expect serial-level traceability — materials, process settings, operator actions, all linked and auditable.',
      <>Ecosystems like <b>Catena-X</b> are building infrastructure where suppliers must share structured data directly into OEM systems.</>,
      'Suppliers who provide requirement-linked evidence qualify faster and retain business longer.',
    ],
  },
  {
    title: 'What this means',
    items: [
      'Every trigger — regulatory, buyer, sustainability — converges on the same need: structured data at material and shipment level.',
      'Factories still relying on PDFs and manual evidence assembly face increasing friction connecting with demanding supply chains.',
    ],
  },
];

const WhyNow = () => (
  <section id="why-now" style={{ padding: 'clamp(56px, 8vw, 96px) clamp(20px, 5vw, 48px)', background: colors.bg }}>
    <div style={{ maxWidth: 1080, margin: '0 auto' }}>
      <div style={{ maxWidth: 760, marginBottom: 48 }}>
        <p style={{ color: colors.teal, fontSize: 12.5, fontFamily: fonts.mono, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600, marginBottom: 16 }}>Why now</p>
        <h2 style={{ fontSize: 'clamp(26px,3.4vw,38px)', fontFamily: fonts.display, lineHeight: 1.3, color: colors.navy, marginBottom: 14 }}>
          The supply chain is shifting from documents to machine-executable data
        </h2>
        <p style={{ color: colors.slateDark, fontSize: 16.5, lineHeight: 1.65, maxWidth: 640 }}>
          Regulation, buyers, and standards bodies are converging on the same requirement at the same time — structured, verifiable data at the material and shipment level.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 1, background: colors.border, border: `1px solid ${colors.border}`, borderRadius: 14, overflow: 'hidden' }}>
        {columns.map((col, i) => (
          <div key={i} style={{ background: colors.bg, padding: '30px 26px' }}>
            <h3 style={{ fontSize: 17, color: colors.navy, marginBottom: 14 }}>{col.title}</h3>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 11 }}>
              {col.items.map((item, j) => (
                <li key={j} style={{ fontSize: 14, color: colors.slate, lineHeight: 1.6, paddingLeft: 16, position: 'relative' }}>
                  <span style={{ position: 'absolute', left: 0, color: colors.teal }}>–</span>{item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyNow;
